// extracted by mini-css-extract-plugin
export default {"loadingContainer":"loading_loadingContainer__ApmN7","loader":"loading_loader__CISyn","rotation":"loading_rotation__JWIaa"};